const WIZ = "Wiz";
const WIZ_VULNERABILITIES = "Wiz Vulnerabilities";

// Wiz and Wiz Vulnerabilities are two definitions of the same product, so a field
// related to both still belongs to a single datasource and gets the Wiz icon.
const mergeDatasourceName = (datasource: string): string =>
  datasource === WIZ_VULNERABILITIES ? WIZ : datasource;

export const getFilterFieldDatasource = (
  relatedDatasources?: readonly string[] | null
): string | undefined => {
  const datasources = new Set(relatedDatasources?.map(mergeDatasourceName));

  return datasources.size === 1 ? [...datasources][0] : undefined;
};
